import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsAgentStudioRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-agent-studio',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent',
	exact: true,
};
